import { config } from '../config.js';

export const useGeocoder = () => {
  const search = async (q, bbox) => {
    const url_geocoder = `${config.url.GEOCODING_SERVICE_URL}/q/${q}`;

    const url_maptiler =
      `${config.url.GEOCODING_MAPTILER_URL}/${q}.json?` +
      new URLSearchParams({
        limit: 7,
        country: ['fr'],
        type: ['address'],
        bbox,
        key: config.token.MAPTILER_KEY,
      });

    try {
      const [response_geocoder, response_maptiler] = await Promise.all([
        fetch(url_geocoder),
        fetch(url_maptiler),
      ]);

      const [results_geocoder, results_maptiler] = await Promise.all([
        response_geocoder.ok ? response_geocoder.json() : null,
        response_maptiler.ok ? response_maptiler.json() : null,
      ]);

      if (!results_geocoder && !results_maptiler) {
        return [];
      }
      return {
        geocoder: results_geocoder,
        maptiler: results_maptiler,
      };
    } catch (error) {
      console.error('Erreur chercher les adresses', error);
    }
  };
  const reverse = async (lng, lat, language) => {
    const url =
      `${config.url.GEOCODING_MAPTILER_URL}/${lng},${lat}.json?` +
      new URLSearchParams({
        country: ['fr'],
        limit: 1,
        language,
        types: ['address', 'poi', 'place'],
        key: config.token.MAPTILER_KEY,
      });
    const results = await fetch(url)
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('Erreur chercher une adresse en reverse');
      })
      .catch((error) => {
        console.log('error geocoder reverse', error);
      });
    return results;
  };

  return {
    search,
    reverse,
  };
};
